import '../types/index.mjs';
import { normalizeSortResult } from './array.mjs';
import { checkUnreachable } from './errors.mjs';
import { StoreId } from '../types/generated.mjs';
"use strict";
var SortSiteId = /* @__PURE__ */(SortSiteId2 => {
  SortSiteId2["Store"] = "store";
  SortSiteId2["Techspecs"] = "techspecs";
  return SortSiteId2;
})(SortSiteId || {});
const getSortWeightTagRegex = (site, store) => {
  switch (site) {
    case "techspecs" /* Techspecs */:
      {
        return /techspecs-sort-weight:(-?\d+)/;
      }
    case "store" /* Store */:
      {
        switch (store) {
          case StoreId.Us:
            return /pro-sort-weight:(-?\d+)/;
          case StoreId.Ca:
          case StoreId.Cn:
          case StoreId.Eu:
          case StoreId.Me:
          case StoreId.Uk:
          case StoreId.Za:
          case StoreId.In:
          case StoreId.Sg:
          case StoreId.Jp:
          case StoreId.Br:
          case StoreId.Tw:
          case StoreId.Mx:
          case StoreId.Ph:
            return /pro-sort-weight:(-?\d+):other/;
          case null:
          case void 0:
            {
              return null;
            }
          default:
            checkUnreachable(store);
            return null;
        }
      }
    default:
      {
        checkUnreachable(site);
        return null;
      }
  }
};
const getTagsSortWeight = (tags, site, store) => {
  let regExp = getSortWeightTagRegex(site, store);
  let tag = regExp ? tags.find(tag2 => regExp?.test(tag2.name)) : void 0;
  if (!tag && store !== StoreId.Us) {
    regExp = getSortWeightTagRegex(site, StoreId.Us);
    if (!regExp) {
      return void 0;
    }
    tag = tags.find(tag2 => regExp?.test(tag2.name));
  }
  if (!tag || !regExp) {
    return void 0;
  }
  const match = regExp.exec(tag.name)?.[1];
  return match ? parseInt(match) : void 0;
};
const sortByTagWeight = (site, store) => (current, next) => {
  const currentSortWeight = getTagsSortWeight(current.tags, site, store) ?? -1;
  const nextSortWeight = getTagsSortWeight(next.tags, site, store) ?? -1;
  return normalizeSortResult(nextSortWeight - currentSortWeight);
};
export { SortSiteId, getTagsSortWeight, sortByTagWeight };
//# sourceMappingURL=product.mjs.map
